import {
  BROWSE_CONTENT_CHANGED,
  GROUP_CREATE_SUCCESS,
  GROUP_DELETE_SUCCESS,
  GROUP_UPDATE_SUCCESS,
  PLAYLIST_DELETE_BATCH_SUCCESS,
  PLAYLIST_METADATA_SAVE_SUCCESS,
  TRACK_CREATE_SUCCESS,
  TRACK_DELETE_BATCH_SUCCESS,
  TRACK_GROUP_CHANGE_SUCCESS,
  TRACK_MERGE_SUCCESS,
  TRACK_METADATA_SAVE_SUCCESS,
  TRACKS_UPLOADER_SAVE_SUCCESS,
} from '@disco/constants/ActionTypes'

/**
 * STL-1248: actions that can add, remove or rename what Browse lists. Both
 * Browse caches (search result types and library views) drop everything they
 * hold on these, so the next switch requests fresh results.
 */
export const BROWSE_CONTENT_CHANGES: readonly string[] = [
  // Tracks or playlists moved in or out of a group (including "Remove from
  // Browse"); their load batches look the same as any other load, so the move
  // says so explicitly
  BROWSE_CONTENT_CHANGED,
  TRACK_GROUP_CHANGE_SUCCESS,
  TRACK_CREATE_SUCCESS,
  TRACKS_UPLOADER_SAVE_SUCCESS,
  TRACK_DELETE_BATCH_SUCCESS,
  TRACK_MERGE_SUCCESS,
  PLAYLIST_DELETE_BATCH_SUCCESS,
  PLAYLIST_METADATA_SAVE_SUCCESS,
  // A renamed or re-tagged track can join or leave the results of a search
  TRACK_METADATA_SAVE_SUCCESS,
  GROUP_CREATE_SUCCESS,
  GROUP_DELETE_SUCCESS,
  GROUP_UPDATE_SUCCESS,
]
